import React from 'react'
import * as styles from './StatusIndicators.styles'
import { useTranslation } from 'react-i18next'

export const Active = () => {
  const { t } = useTranslation('settlements')
  return (
    <div className={styles.iconRow}>
      <span className='icon icon-tick' />&nbsp;<span className={styles.semibold}>{t('Active')}</span>
    </div>
  )
}

export const Paused = () => {
  const { t } = useTranslation('settlements')
  return (
    <div className={styles.iconRow}>
      <span className='icon icon-error-small' />&nbsp;<span className={styles.pausedText}>{t('Paused')}</span>
    </div>
  )
}
